(function () {
  'use strict';

  // ── Constants ──────────────────────────────────────────────────────────────
  var OTP_API   = '/main/webappotplogin';
  var LOGIN_API = '/main/login';

  // Preserve ?flow=... from the landing URL in all API calls
  var _flowParam = new URLSearchParams(window.location.search).get('flow');
  var _flowSuffix = _flowParam ? '&flow=' + encodeURIComponent(_flowParam) : '';
  var RESEND_SECONDS = 30;

  // ── Config from server (via data- attributes on the root element) ──────────
  var root        = document.querySelector('.loginssr');
  var IS_DEV      = root.dataset.isDev === 'true';
  var DEV_HIJACK  = root.dataset.devHijackId || '';
  var DEV_CLICK_START = parseInt(root.dataset.devClickCount || '0', 10);

  // ── State ──────────────────────────────────────────────────────────────────
  var state = {
    panel: 'otp',          // 'otp' | 'email'
    otpWasSent: false,
    otpWasSentEmail: false, // loginOtpSent (email flow re-verification)
    logoutOthers: false,
    devClickCount: DEV_CLICK_START,
    showLogsClickCount: 0,
    countDownTimer: null,
    resendDisabled: false,
    emailCcodeShown: false,
    otpCcodeShown: false,
    loginSuccess: false,
    tabsLocked: false,
  };

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[-.$?*|{}()[\]\\/\\+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function cookieParentDomain() {
    var host = location.hostname;
    if (host === 'smaac.in' || host.endsWith('.smaac.in')) return '.smaac.in';
    // Fallback: no explicit domain so it works on localhost
    return null;
  }

  function setHwidCookie(val) {
    var parts = ['hwid=' + encodeURIComponent(val), 'path=/'];
    var domain = cookieParentDomain();
    if (domain) parts.push('domain=' + domain);
    // 60 days validity
    var maxAge = 60 * 60 * 24 * 60;
    parts.push('Max-Age=' + maxAge);
    if (location.protocol === 'https:') parts.push('Secure');
    parts.push('SameSite=Lax');
    document.cookie = parts.join('; ');
  }

  var hwid = getCookie('hwid');
  if (typeof hwid !== 'string' || !hwid) {
    hwid = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Math.random().toString(36).slice(2) + Date.now());
    setHwidCookie(hwid);
  }

  // ── DOM refs ───────────────────────────────────────────────────────────────
  var $ = function (id) { return document.getElementById(id); };

  var otpPanel          = $('otp-panel');
  var emailPanel        = $('email-panel');
  var btnOtpTab         = $('btn-otp-tab');
  var btnEmailTab       = $('btn-email-tab');

  var otpPreSend        = $('otp-pre-send');
  var otpPostSend       = $('otp-post-send');
  var otpForm           = $('otp-form');
  var otpCountryCode    = $('otp-country-code');
  var otpPhone          = $('otp-phone');
  var otpFieldRow       = $('otp-field-row');
  var otpCode           = $('otp-code');
  var otpCcodeRow       = $('otp-ccode-row');
  var otpCcode          = $('otp-ccode');
  var otpSubmitBtn      = $('otp-submit-btn');
  var otpBtnSpinner     = $('otp-btn-spinner');
  var otpBtnText        = $('otp-btn-text');
  var otpLogoutBtn      = $('otp-logout-others-btn');
  var otpResendRow      = $('otp-resend-row');
  var otpCountdownText  = $('otp-countdown-text');
  var otpCountdown      = $('otp-countdown');
  var otpResendBtn      = $('otp-resend-btn');
  var otpTerms          = $('otp-terms');

  var emailForm         = $('email-form');
  var emailFieldsStd    = $('email-fields-std');
  var emailHijackFields = $('email-hijack-fields');
  var emailEmail        = $('email-email');
  var emailPwd          = $('email-pwd');
  var emailPwdToggle    = $('email-pwd-toggle');
  var emailHijackId     = $('email-hijack-id');
  var emailCcodeRow     = $('email-ccode-row');
  var emailCcode        = $('email-ccode');
  var emailTestdbRow    = $('email-testdb-row');
  var emailTestdb       = $('email-testdb');
  var emailOtpRow       = $('email-otp-row');
  var emailOtp          = $('email-otp');
  var emailSubmitBtn    = $('email-submit-btn');
  var emailBtnSpinner   = $('email-btn-spinner');
  var emailBtnText      = $('email-btn-text');
  var emailLogoutBtn    = $('email-logout-others-btn');
  var knownLogins       = $('known-logins');
  var alertBox          = $('alert-box');
  var licenseContinueBtn = $('license-continue-btn');
  var builtBySmaac      = $('built-by-smaac');
  var todayDateEl       = $('today-date');
  var loginTypeTab      = $('login-type-tab');
  var emailFooterSection= $('email-footer-section');


  // ── Helpers ────────────────────────────────────────────────────────────────
  function show(el) { el.classList.remove('hidden'); }
  function hide(el) { el.classList.add('hidden'); }

  function setTab(panel) {
    resetPanels();
    state.panel = panel;
    var isOtp = panel === 'otp';

    // panels
    isOtp ? show(otpPanel) : hide(otpPanel);
    isOtp ? hide(emailPanel) : show(emailPanel);

    // tab button styles
    var activeClass = ['bg-blue-600', 'text-white'];
    var inactiveClass = ['bg-white', 'text-blue-600'];
    activeClass.forEach(function (c) {
      (isOtp ? btnOtpTab : btnEmailTab).classList.add(c);
      (isOtp ? btnEmailTab : btnOtpTab).classList.remove(c);
    });
    inactiveClass.forEach(function (c) {
      (isOtp ? btnEmailTab : btnOtpTab).classList.add(c);
      (isOtp ? btnOtpTab : btnEmailTab).classList.remove(c);
    });
  }

  function showAlert(msg, kind) {
    // kind: 'danger' | 'info' | 'success'
    var colorMap = {
      danger:  'bg-red-100 text-red-800 border border-red-300',
      info:    'bg-blue-100 text-blue-800 border border-blue-300',
      success: 'bg-green-100 text-green-800 border border-green-300',
    };
    alertBox.className = 'mt-4 rounded-md px-4 py-3 text-sm font-medium ' + (colorMap[kind] || colorMap.danger);
    alertBox.textContent = msg;
    show(alertBox);
  }

  function clearAlert() { hide(alertBox); }

  function bindSanitizedInput(el, pattern) {
    el.addEventListener('input', function () {
      var pos = el.selectionStart;
      var cleaned = el.value.replace(pattern, '');
      if (cleaned === el.value) return;
      el.value = cleaned;
      el.setSelectionRange(Math.max(0, pos - 1), Math.max(0, pos - 1));
    });
  }

  function lockTabs() {
    state.tabsLocked = true;
    [btnOtpTab, btnEmailTab].forEach(function (b) {
      b.disabled = true;
      b.classList.add('opacity-40', 'cursor-not-allowed');
    });
  }

  function unlockTabs() {
    state.tabsLocked = false;
    [btnOtpTab, btnEmailTab].forEach(function (b) {
      b.disabled = false;
      b.classList.remove('opacity-40', 'cursor-not-allowed');
    });
  }

  function resetPanels() {
    unlockTabs();
    hide(licenseContinueBtn);
    show(otpPreSend); hide(otpPostSend); hide(otpFieldRow);
    state.otpCcodeShown ? show(otpCcodeRow) : hide(otpCcodeRow);
    hide(otpResendRow); show(otpSubmitBtn); hide(otpLogoutBtn);
    show(otpTerms); otpBtnText.textContent = 'Get OTP';
    clearInterval(state.countDownTimer);
    state.otpWasSent = false;
    IS_DEV ? hide(emailFieldsStd) : show(emailFieldsStd);
    IS_DEV ? show(emailHijackFields) : hide(emailHijackFields);
    state.emailCcodeShown ? show(emailCcodeRow) : hide(emailCcodeRow);
    hide(emailOtpRow); show(emailSubmitBtn); hide(emailLogoutBtn);
    state.otpWasSentEmail = false;
    state.loginSuccess = false;
  }

  function setBusy(spinnerEl, textEl, btn, busy) {
    spinnerEl.classList.toggle('hidden', !busy);
    btn.disabled = busy;
  }

  function clearLocalStorageKeepTokens() {
    var kept = localStorage.getItem('storedApiTokens');
    localStorage.clear();
    if (kept) { localStorage.setItem('storedApiTokens', kept); }
  }

  function bindCompanySelect(select, submit) {
    select.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      submit();
    });
    select.addEventListener('wheel', function (e) {
      if (!select.options.length || e.deltaY === 0) return;
      e.preventDefault();
      var next = select.selectedIndex + (e.deltaY > 0 ? 1 : -1);
      next = Math.max(0, Math.min(select.options.length - 1, next));
      if (next === select.selectedIndex) return;
      select.selectedIndex = next;
    }, { passive: false });
  }

  function post(url, data) {
    clearLocalStorageKeepTokens();
    return fetch(url + '?dswc=landing' + _flowSuffix, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(data),
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) { return Promise.reject(body); }
        return body;
      });
    });
  }

  // ── Countdown timer ────────────────────────────────────────────────────────
  function startCountdown() {
    var remaining = RESEND_SECONDS;
    state.resendDisabled = true;
    hide(otpResendBtn);
    show(otpCountdownText);
    show(otpResendRow);

    clearInterval(state.countDownTimer);
    state.countDownTimer = setInterval(function () {
      remaining -= 1;
      var mm = '00';
      var ss = remaining.toString().padStart(2, '0');
      otpCountdown.textContent = mm + ':' + ss;
      if (remaining <= 0) {
        clearInterval(state.countDownTimer);
        state.resendDisabled = false;
        hide(otpCountdownText);
        show(otpResendBtn);
      }
    }, 1000);
  }

  // ── OTP ccode dropdown population ─────────────────────────────────────────
  function populateCcodeSelect(ccodes) {
    otpCcode.innerHTML = '';
    ccodes.forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      otpCcode.appendChild(opt);
    });
  }

  // ── OTP panel state transitions ───────────────────────────────────────────
  function enterOtpSentState() {
    state.otpWasSent = true;
    lockTabs();
    hide(otpPreSend);
    show(otpPostSend);
    show(otpFieldRow);
    hide(otpTerms);
    otpBtnText.textContent = 'Verify OTP';
    startCountdown();
  }

  function enterOtpVerifyFailState() {
    // Stay in verify mode; keep phone locked
    otpCode.value = '';
    otpCode.focus();
  }

  // ── Known logins (localStorage quick-switch) ───────────────────────────────
  function renderKnownLogins() {
    var stored = [];
    try { stored = JSON.parse(localStorage.getItem('storedApiTokens') || '[]'); } catch { stored = []; }
    knownLogins.innerHTML = '';
    stored.forEach(function (log) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/ssr/dashboard/landing?apitoken=' + encodeURIComponent(log.tok);
      a.textContent = log.userName + ' | ' + log.company;
      li.appendChild(a);
      knownLogins.appendChild(li);
    });
  }

  // ── Navigate after successful login ───────────────────────────────────────
  function onLoginSuccess(data, domain) {
    domain = domain || '';
    var redirectUrl = domain + data.redirectTo + '?apitoken=' + data.token;
    if (data.license_expiry_message) {
      showAlert(data.license_expiry_message, 'danger');
      show(licenseContinueBtn);
      licenseContinueBtn.onclick = function () { window.location.href = redirectUrl; };
      hide(loginTypeTab)
      // Hide remaining form inputs and submit button for the active panel
      if (state.panel === 'otp') {
        hide(otpPreSend); hide(otpPostSend); hide(otpFieldRow);
        hide(otpCcodeRow); hide(otpResendRow); hide(otpSubmitBtn);
        hide(otpForm)
      } else {
        hide(emailFieldsStd); hide(emailHijackFields); hide(emailCcodeRow);
        hide(emailTestdbRow); hide(emailOtpRow); hide(emailSubmitBtn);
        hide(emailFooterSection); 
      }
    } else {
      window.location.href = redirectUrl;
    }
  }

  // ── OTP LOGIN FLOW ─────────────────────────────────────────────────────────
  function attemptOtpLogin(resend, logoutOthers) {
    clearAlert();
    var phone = otpPhone.value.trim();
    if (!phone) { showAlert('Please enter your mobile number.', 'danger'); return; }

    setBusy(otpBtnSpinner, otpBtnText, otpSubmitBtn, true);
    hide(otpLogoutBtn);

    var params = {
      phone: phone,
      countryCode: otpCountryCode.value,
      ccode: otpCcode.value || null,
      logoutOthers: logoutOthers ? 'y' : 'n',
    };

    if (state.otpWasSent && !resend) {
      var otpVal = otpCode.value.trim();
      if (!otpVal) {
        showAlert('Please enter the OTP.', 'danger');
        setBusy(otpBtnSpinner, otpBtnText, otpSubmitBtn, false);
        return;
      }
      params.otp = otpVal;
    }

    post(OTP_API, params)
      .then(function (data) {
        if (data.use_chost && !data.ok) {
          // Retry against the correct host
          return post('https://' + data.use_chost + OTP_API, params)
            .then(function (d2) { return handleOtpResponse(d2, data.use_chost); });
        }
        return handleOtpResponse(data, null);
      })
      .catch(function (err) { showOtpError(err); })
      .finally(function () {
        if (!state.loginSuccess) {
          setBusy(otpBtnSpinner, otpBtnText, otpSubmitBtn, false);
        }
      });
  }

  function handleOtpResponse(data, chost) {
    var domain = chost ? 'https://' + chost : '';

    if (data.multiple === true && !data.otpSent) {
      // Show ccode picker before sending OTP
      show(otpCcodeRow);
      state.otpCcodeShown = true;
      populateCcodeSelect(data.possible_ccodes || []);
      showAlert('Please select your company code.', 'info');
      return;
    }

    if (data.otpSent === true) {
      if (data.multiple && (data.possible_ccodes || []).length > 0) {
        show(otpCcodeRow);
        state.otpCcodeShown = true;
        populateCcodeSelect(data.possible_ccodes);
      }
      enterOtpSentState();
      showAlert('Please enter the OTP sent to your registered email or phone.', 'info');
      return;
    }

    if (data.ok === true) {
      state.loginSuccess = true;
      setBusy(otpBtnSpinner, otpBtnText, otpSubmitBtn, true); //disabling the submit btn
      onLoginSuccess(data, domain);
      return;
    }

    if (data.code === 409) {
      showAlert(
        'Too many sessions active. Confirm to log out all existing sessions.',
        'danger'
      );
      show(otpLogoutBtn);
      return;
    }

    if (data.code === 429) {
      showAlert('Please wait for 10 seconds before trying again.', 'danger');
      return;
    }
    if (data.code === 403) {
      showAlert(data.description || 'Login failed. Please re-check your OTP.', 'danger');
      if (state.otpWasSent) {
        enterOtpVerifyFailState();
      }
      return;
    }

    var msg = (data.description) ? data.description : 'Login failed. Please re-check your details.';
    showAlert(msg, 'danger');
  }

  function showOtpError(err) {
    var msg = (err && (err.description || err.reason))
      ? (err.description || err.reason)
      : 'An unexpected error occurred. Please try again.';
    showAlert(msg, 'danger');
  }

  // ── EMAIL LOGIN FLOW ───────────────────────────────────────────────────────
  function attemptEmailLogin(logoutOthers) {
    clearAlert();

    var ccode = emailCcode.value.trim();

    var hijackId = emailHijackId.value.trim();
    var isHijack = !emailHijackFields.classList.contains('hidden') && !!hijackId;

    var params = {
      ccode: ccode || null,
      testDb: emailTestdb.checked,
      hwid: hwid,
      logoutOthers: logoutOthers ? 'y' : 'n',
    };

    if (isHijack) {
      params.hijackId = parseInt(hijackId, 10);
      // handle_login needs email/pwd present even for hijack
      params.email = '';
      params.pwd   = '';
    } else {
      var email = emailEmail.value.trim().toLowerCase();
      var pwd   = emailPwd.value;
      if (!email || !pwd) {
        showAlert('Please enter your email and password.', 'danger');
        return;
      }
      params.email = email;
      params.pwd   = pwd;
    }

    if (state.otpWasSentEmail) {
      var otpVal = emailOtp.value.trim();
      if (!otpVal) { showAlert('Please enter the OTP.', 'danger'); return; }
      params.otp = otpVal;
    }

    setBusy(emailBtnSpinner, emailBtnText, emailSubmitBtn, true);
    hide(emailLogoutBtn);

    post(LOGIN_API, params)
      .then(function (data) {
        if (data.use_chost && !data.ok) {
          return post('https://' + data.use_chost + LOGIN_API, params)
            .then(function (d2) { return handleEmailResponse(d2, data.use_chost); });
        }
        return handleEmailResponse(data, null);
      })
      .catch(function (err) { showEmailError(err); })
      .finally(function () {
        if (!state.loginSuccess) {
          setBusy(emailBtnSpinner, emailBtnText, emailSubmitBtn, false);
        }
      });
  }

  function handleEmailResponse(data, chost) {
    var domain = chost ? 'https://' + chost : '';

    if (data.ok === true) {
      state.loginSuccess = true;
      setBusy(emailBtnSpinner, emailBtnText, emailSubmitBtn, true);//disabling the submit btn
      onLoginSuccess(data, domain);
      return;
    }

    if (data.code === 409) {
      showAlert(
        'Too many sessions active. Confirm to log out all existing sessions.',
        'danger'
      );
      show(emailLogoutBtn);
      return;
    }

    if (data.loginOtpSent === true) {
      state.otpWasSentEmail = true;
      lockTabs();
      show(emailOtpRow);
      showAlert(
        'New browser/device detected. For security reasons, a verification OTP has been sent to your registered contact. Please use it to complete the login process.',
        'danger'
      );
      return;
    }

    if (data.multiple === true) {
      show(emailCcodeRow);
      state.emailCcodeShown = true;
      emailCcode.innerHTML = '';
      (data.possible_ccodes || []).forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        emailCcode.appendChild(opt);
      });
      showAlert('Please select your company code.', 'info');
      return;
    }

    if (data.code === 429) {
      showAlert('Please wait for 10 seconds before trying again.', 'danger');
      return;
    }

    var msg = (data.description) ? data.description : 'Login failed. Please re-check your credentials.';
    if(data.redirectTo) window.location.href = data.redirectTo;
    showAlert(msg, 'danger');
  }

  function showEmailError(err) {
    var msg = (err && (err.description || err.reason))
      ? (err.description || err.reason)
      : 'An unexpected error occurred. Please try again.';
    showAlert(msg, 'danger');
  }

  // ── Dev / hijack unlock ────────────────────────────────────────────────────
  function onDevClick() {
    state.devClickCount += 1;
    if (state.devClickCount > 5) {
      show(emailTestdbRow);
      if (IS_DEV) {
        show(emailHijackFields);
        hide(emailFieldsStd);
      }
    }
  }

  // ── showLogs (date click) ──────────────────────────────────────────────────
  function onShowLogsClick() {
    state.showLogsClickCount += 1;
    if (state.showLogsClickCount <= 3) return;
    state.showLogsClickCount = 0;

    var data = { localStorage: {}, cookies: {}, serviceWorker: {} };
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      data.localStorage[k] = localStorage.getItem(k);
    }
    document.cookie.split('; ').forEach(function (c) {
      var idx = c.indexOf('=');
      data.cookies[c.substring(0, idx)] = decodeURIComponent(c.substring(idx + 1));
    });
    caches.keys().then(function (names) {
      names.forEach(function (name) {
        caches.open(name).then(function (cache) {
          cache.keys().then(function (keys) {
            data.serviceWorker[name] = keys.map(function (r) { return r.url; }).join(', ');
          });
        });
      });
    });

    var text = JSON.stringify(data, null, 2);
    if (confirm('Copy local storage contents to clipboard?')) {
      navigator.clipboard.writeText(text).catch(function () { alert(text); });
    }
  }

  // ── Wire events ───────────────────────────────────────────────────────────
  btnOtpTab.addEventListener('click', function () { if (state.tabsLocked) return; setTab('otp'); clearAlert(); });
  btnEmailTab.addEventListener('click', function () { if (state.tabsLocked) return; setTab('email'); clearAlert(); });

  otpForm.addEventListener('submit', function (e) {
    e.preventDefault();
    attemptOtpLogin(false);
  });

  otpResendBtn.addEventListener('click', function () {
    if (state.resendDisabled) return;
    otpCode.value = '';
    attemptOtpLogin(true, false);
  });

  otpLogoutBtn.addEventListener('click', function () {
    attemptOtpLogin(false, true);
  });

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    attemptEmailLogin(false);
  });

  emailLogoutBtn.addEventListener('click', function () {
    attemptEmailLogin(true);
  });

  emailPwd.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.shiftKey) return;
    e.preventDefault();
    (emailCcodeRow.classList.contains('hidden') ? emailSubmitBtn : emailCcode).focus();
  });
  bindCompanySelect(otpCcode, function () { attemptOtpLogin(false); });
  bindCompanySelect(emailCcode, function () { attemptEmailLogin(false); });

  emailPwdToggle.addEventListener('click', function () {
    var isPassword = emailPwd.type === 'password';
    emailPwd.type = isPassword ? 'text' : 'password';
    // swap eye icon path — toggle between show and hide
    var paths = emailPwdToggle.querySelectorAll('path');
    if (isPassword) {
      // eye-slash: one path suffices
      paths[0].setAttribute('d', 'M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.293-3.95M6.634 6.634A9.956 9.956 0 0112 5c4.477 0 8.268 2.943 9.542 7a10.054 10.054 0 01-4.132 5.411M3 3l18 18');
      if (paths[1]) paths[1].setAttribute('d', '');
    } else {
      paths[0].setAttribute('d', 'M15 12a3 3 0 11-6 0 3 3 0 016 0z');
      if (paths[1]) paths[1].setAttribute('d', 'M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z');
    }
  });

  // email lowercasing (match Vue behaviour)
  emailEmail.addEventListener('input', function () {
    emailEmail.value = emailEmail.value.replace(/\s/g, '').toLowerCase();
  });
  bindSanitizedInput(emailPwd, /\s/g);
  bindSanitizedInput(otpPhone, /\D/g);
  bindSanitizedInput(otpCode, /\D/g);
  bindSanitizedInput(emailOtp, /\D/g);

  builtBySmaac.addEventListener('click', onDevClick);
  builtBySmaac.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onDevClick(); }
  });

  if (todayDateEl) {
    todayDateEl.style.cursor = 'pointer';
    todayDateEl.addEventListener('click', onShowLogsClick);
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  // Pre-fill dev defaults
  if (IS_DEV) {
    // ccode is auto-resolved server-side from email; no pre-fill needed
    emailHijackId.value = DEV_HIJACK;
    emailTestdb.checked = true;
    // Show hijack fields immediately (same as Vue's devClickCount starting at 6)
    state.devClickCount = 6;
    show(emailTestdbRow);
    show(emailHijackFields);
    hide(emailFieldsStd);
    setTab('email');
  } else {
    setTab('otp');
  }

  renderKnownLogins();

})();
